import React, { useCallback } from 'react';
import type { FC } from 'react';
import { TextInput } from '@wix/cli-ui-kit';
import { join } from 'node:path';
import { match } from 'variant';
import {
  validateDirectory,
  validateFolderName,
  validatePackageName,
} from '../validations/index.js';

export const validateAppFolder = async (
  targetParentFolder: string,
  appFolder: string
) => {
  try {
    validateFolderName(appFolder);
  } catch (error) {
    return (error as Error).message;
  }

  if (!(await validateDirectory(join(targetParentFolder, appFolder)))) {
    return `Provided directory "${appFolder}" is not empty`;
  }

  const npmValidationErrors = await validatePackageName(appFolder);

  return match(npmValidationErrors, {
    Ok: () => true as const,
    Error: ({ payload }) =>
      `Invalid folder name. Fix the following issues: ${payload.join(', ')}`,
  });
};

export const ChooseFolder: FC<{
  initialFolderName: string;
  targetParentFolder: string;
  onSubmit: (data: { folderName: string }) => void;
}> = ({ initialFolderName, targetParentFolder, onSubmit }) => {
  const validate = useCallback(
    async (appFolder: string) =>
      validateAppFolder(targetParentFolder, appFolder),
    [targetParentFolder]
  );

  return (
    <TextInput
      label="Enter the folder name for your project."
      placeholder={initialFolderName}
      onSubmit={(folderName) => onSubmit({ folderName })}
      validate={validate}
      inCreateFlow
    />
  );
};
